import styled from "styled-components";

export const ChatArea = styled.div`
  padding: 20px;
  border-bottom: 1px solid #c9d4db;
  background-color: rgba(228, 233, 236, 0.17);
`;
